package top.wcpe.allincore.dsl.ir.model.hud

import kotlin.jvm.JvmField

/** HUD 布局策略：描述锚点基础位置之外的偏移、安全区与 vanilla HUD 避让。 */
class HudLayoutPolicy(
    val offsetX: Int,
    val offsetY: Int,
    // 保留 boolean is-getter：Kotlin 对 is 前缀 Boolean 属性生成 isSafeArea() / isAvoidVanilla()，与原 Java 互操作签名一致。
    val isSafeArea: Boolean,
    val isAvoidVanilla: Boolean,
) {

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is HudLayoutPolicy) return false
        return offsetX == other.offsetX &&
            offsetY == other.offsetY &&
            isSafeArea == other.isSafeArea &&
            isAvoidVanilla == other.isAvoidVanilla
    }

    // 逐位复刻 java.util.Objects.hash(offsetX, offsetY, safeArea, avoidVanilla)：种子 1、31 倍累乘、元素用各自 hashCode。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + offsetX
        result = 31 * result + offsetY
        result = 31 * result + isSafeArea.hashCode()
        result = 31 * result + isAvoidVanilla.hashCode()
        return result
    }

    override fun toString(): String =
        "HudLayoutPolicy{" +
            "offsetX=" + offsetX +
            ", offsetY=" + offsetY +
            ", safeArea=" + isSafeArea +
            ", avoidVanilla=" + isAvoidVanilla +
            '}'

    companion object {
        // @JvmField 使 Java 侧仍以 HudLayoutPolicy.DEFAULT 静态字段访问（不经 getter）。
        @JvmField
        val DEFAULT = HudLayoutPolicy(0, 0, isSafeArea = true, isAvoidVanilla = true)
    }
}
